import { useAtomValue, useSetAtom } from "jotai";
import { type JSX, useEffect } from "react";

import { PickerField } from "@frontend/shared/picker-field";
import { useLingui } from "@lingui/react/macro";

import {
  billingProjectsAtom,
  loadBillingProjectsAtom,
  projectEditorAtom,
  projectForm,
} from "../stores/editor";
import { Section } from "./Section";

/** Which subscription carries the bill, when several share one. */
export function GroupingSection(): JSX.Element {
  const { t } = useLingui();

  const { project } = useAtomValue(projectEditorAtom);
  const billingProjects = useAtomValue(billingProjectsAtom);
  const loadBillingProjects = useSetAtom(loadBillingProjectsAtom);

  const clientId = useAtomValue(projectForm.fields.clientId.atom);

  // The candidates are the client's own subscriptions, so they follow it.
  useEffect(() => {
    void loadBillingProjects(clientId ?? null, project?.id ?? null);
  }, [loadBillingProjects, clientId, project?.id]);

  return (
    <Section icon="Layers" legend={t`Grouped billing`}>
      <PickerField
        label={t`Bill grouped on`}
        placeholder={t`None, billed on its own`}
        items={billingProjects}
        field={projectForm.fields.subscription.fields.billingProjectId}
        fallbackLabel={project?.subscription?.billingProjectLabel}
      />
    </Section>
  );
}
